import { getData, postData, putData, deleteData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import { getAPIEndpoints, handleApiError } from 'src/utils';

const scholarshipTypeActionTypes = {
  GET_SCHOLARSHIP_TYPES_SUCCESS: 'GET_SCHOLARSHIP_TYPES_SUCCESS',
  GET_SCHOLARSHIP_DOCUMENTS_SUCCESS: 'GET_SCHOLARSHIP_DOCUMENTS_SUCCESS',
};

const getScholarshipTypesList = active => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const activeParam = active === undefined ? '' : `?active=${active}`;
    const response = await getData(`${getAPIEndpoints().scholarshipTypeList}${activeParam}`);
    dispatch({
      type: scholarshipTypeActionTypes.GET_SCHOLARSHIP_TYPES_SUCCESS,
      payload: response.data?.data ?? [],
    });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const createScholarshipType = ({ name, displayName, documentTypeIds }) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await postData(`${getAPIEndpoints().createScholarshipType}`, {
      name,
      displayName,
      documentTypeIds,
    });
    dispatch(ApiCallSuccessAction({ message: 'Scholarship type created successfully' }));
    dispatch(getScholarshipTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const updateScholarshipType = ({ id, name, displayName, documentTypeIds }) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(
      `${getAPIEndpoints().updateScholarshipType.replace('{id}', id)}`,
      { name, displayName, documentTypeIds }
    );
    dispatch(ApiCallSuccessAction({ message: 'Scholarship type updated successfully' }));
    dispatch(getScholarshipTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const toggleScholarshipTypeActive = (id, active) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await deleteData(
      `${getAPIEndpoints().toggleScholarshipTypeActive.replace('{id}', id)}?active=${active}`
    );
    dispatch(
      ApiCallSuccessAction({
        message: `Scholarship type ${active ? 'activated' : 'deactivated'} successfully`,
      })
    );
    dispatch(getScholarshipTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const getDocumentTypesList = active => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const activeParam = active === undefined ? '' : `?active=${active}`;
    const response = await getData(`${getAPIEndpoints().documentTypeList}${activeParam}`);
    dispatch({
      type: scholarshipTypeActionTypes.GET_SCHOLARSHIP_DOCUMENTS_SUCCESS,
      payload: response.data?.data ?? [],
    });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const createDocumentType = ({
  displayName,
  active,
  isReusableDoc,
  isHallTicketRequired,
  isRepurchaseRequired,
}) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await postData(`${getAPIEndpoints().createDocumentType}`, {
      displayName,
      active,
      isReusableDoc,
      isHallTicketRequired,
      isRepurchaseRequired,
    });
    dispatch(ApiCallSuccessAction({ message: 'Document type created successfully' }));
    dispatch(getDocumentTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const updateDocumentType = (
  id,
  { displayName, active, isReusableDoc, isHallTicketRequired, isRepurchaseRequired }
) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(`${getAPIEndpoints().updateDocumentType.replace('{id}', id)}`, {
      displayName,
      active,
      isReusableDoc,
      isHallTicketRequired,
      isRepurchaseRequired,
    });
    dispatch(ApiCallSuccessAction({ message: 'Document type updated successfully' }));
    dispatch(getDocumentTypesList());
    dispatch(getScholarshipTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const toggleDocumentTypeActive = (id, active) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await deleteData(
      `${getAPIEndpoints().toggleDocumentTypeActive.replace('{id}', id)}?active=${active}`
    );
    dispatch(
      ApiCallSuccessAction({
        message: `Document type ${active ? 'activated' : 'deactivated'} successfully`,
      })
    );
    dispatch(getDocumentTypesList());
    dispatch(getScholarshipTypesList());
    return response.data?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

export {
  scholarshipTypeActionTypes,
  getScholarshipTypesList,
  createScholarshipType,
  updateScholarshipType,
  toggleScholarshipTypeActive,
  getDocumentTypesList,
  createDocumentType,
  updateDocumentType,
  toggleDocumentTypeActive,
};
